import { Language } from '@/modules/graphql/codegen/graphql'

import type { Language as I18nLanguage } from './i18n'

export const toI18nLanguage = (
  language: Language | null | undefined,
): I18nLanguage => (language === Language.De ? 'de' : 'en')

export const toGraphqlLanguage = (language: I18nLanguage): Language =>
  language === 'de' ? Language.De : Language.En
